var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"d-flex flex-row flex-wrap justify-content-between"},[_c('div',{staticClass:"d-flex flex-row"},[_c('h1',[_vm._v(_vm._s(_vm.bannerContent.titre.toUpperCase()))]),_vm._v(" "),_c('div',{staticClass:"align-self-center"},[_vm._v(_vm._s(_vm.num))])]),_vm._v(" "),_c('div',{staticClass:"align-self-center"},[_c('font-awesome-icon',{attrs:{"size":"2x","icon":_vm.bannerContent.icon}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-023bc6c6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Banner.vue
// module id = 461
// module chunks = 0